import React, { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { userAtom } from "../../../../recoil/userAtom";
import { programSetupApi } from "../../../../api/programSetupApi";
import { programSetupDataState } from "../../../../recoil/programSetupDataAtom";

export function ProgramSetup_3_Load() {
  const navigate = useNavigate();
  const user = useRecoilValue(userAtom);
  const setProgramSetupData = useSetRecoilState(programSetupDataState);

  // 마지막 페이지 정보 로드
  const {
    data: lastPageResp,
    isSuccess: isLastPageSuccess,
    isError: isLastPageError,
  } = useQuery(
    ["programSetupLoadLastPage", 3, user?.userId],
    () => programSetupApi.loadLastPage(3),
    {
      cacheTime: 0,
      staleTime: 0,
    }
  );

  // 모든 페이지 데이터 사전 로드
  const {
    data: allDataResp,
    isSuccess: isAllDataSuccess,
    isError: isAllDataError,
  } = useQuery(
    ["programSetupLoadAllData", user?.userId],
    () => programSetupApi.loadAllPageData(),
    {
      cacheTime: 0,
      staleTime: 0,
    }
  );

  useEffect(() => {
    // 두 API 모두 완료되어야 리다이렉트
    const bothSuccess = isLastPageSuccess && isAllDataSuccess;
    const anyError = isLastPageError || isAllDataError;

    if (bothSuccess) {
      // 전체 페이지 데이터를 Recoil atom에 세팅
      if (allDataResp?.data) {
        setProgramSetupData(allDataResp.data);
      }

      const lastPageId = lastPageResp?.result?.pageId;
      const params = lastPageResp?.result?.params;

      // 마지막 페이지로 리다이렉트
      if (lastPageId) {
        const [type, seq] = lastPageId.split("_");

        if (type && seq) {
          const url = params
            ? `/program-setup-3/${type}/${seq}?${params}`
            : `/program-setup-3/${type}/${seq}`;
          navigate(url, {
            replace: true,
          });
        } else {
          navigate("/program-setup-3/result/1", { replace: true });
        }
      } else {
        // 마지막 페이지 정보가 없으면 첫 페이지로
        navigate("/program-setup-3/result/1", { replace: true });
      }
    } else if (anyError) {
      // 에러 발생 시 첫 페이지로
      navigate("/program-setup-3/result/1", { replace: true });
    }
  }, [
    isLastPageSuccess,
    isAllDataSuccess,
    isLastPageError,
    isAllDataError,
    lastPageResp,
    allDataResp,
    navigate,
    setProgramSetupData,
  ]);

  // 로딩 중이거나 리다이렉트 전에는 아무것도 렌더링하지 않습니다.
  return <></>;
}
